import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsapptemplatemessageService {


  url = environment.serverAPI4 + "/api/messageTemplate";

  constructor(private http: HttpClient) { }

  getAllWhatsapptemplatemessage(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllWhatsapptemplatemessageDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getWhatsapptemplatemessageById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditWhatsapptemplatemessage(whatsapptemplatemessage: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, whatsapptemplatemessage);
  }

  whatsapptemplatemessageSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}
